//#region Imports
import { BaseService } from 'src/app/core/services/base-service.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MemberResponsePortalResponseDto } from '@app/core/models/memberResponsePortalResponseDto';
import { Observable } from 'rxjs';
import { OtherHealthInsuranceDto } from '../model/otherHealthInsuranceDto';
//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class OtherHealthInsuranceService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public Save(otherHealthInsuranceDto: OtherHealthInsuranceDto): Observable<MemberResponsePortalResponseDto> {
        return this.Post('/Survey/OtherHealthInsurance', otherHealthInsuranceDto);
    }
    //#endregion Public Methods
}
